import { makeAutoObservable, observable, computed, toJS } from 'mobx';

// import * as api from '@/requests/common';

export default class CommonStore {
  windowSize = 0;
  isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);

  channelIdFromInvitedFriends = '';
  showLoginPop = false;
  loginedInfo = {
    // walletList[x].code
    walletName: '',
    address: '',
    // only metamask have
    jwt: '',
    walletInstance: null,
  };

  constructor() {
    makeAutoObservable(this)
  }

  setWindowSize(size) {
    this.windowSize = size
    // iPad Pro 1024px
    this.isMobile = size < 1025
  }

  setShowLoginPop(show = false) {
    this.showLoginPop = show
  }

  setLoginedInfo(walletName, address, walletInstance, jwt) {
    this.loginedInfo = {
      walletName, address, walletInstance, jwt
    }
  }

  setChannelIdFromInvitedFriends(value) {
    this.channelIdFromInvitedFriends = value
  }

  // async login() {

  // }

}
